import styled from 'styled-components'
import { GRAYSCALE_300, VIOLET_600 } from '../../styles/colors'

export const RadioButtonLabel = (styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

interface CustomRadioProps {
  $outlineColor?: string;
  $outlineWidth?: number;
  $centerColor?: string;
  $size?: number;
}

export const CustomRadio = (styled.span<CustomRadioProps>`
  display: inline-block;
  width: ${props => props.$size || 20}px;
  height: ${props => props.$size || 20}px;
  border-radius: 50%;
  border: ${props => props.$outlineWidth || 2}px solid ${props => props.$outlineColor || GRAYSCALE_300};
  position: relative;

  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: ${props => (props.$size || 20) / 2}px;
    height: ${props => (props.$size || 20) / 2}px;
    border-radius: 50%;
    background-color: ${props => props.$centerColor || VIOLET_600};
    opacity: 0;
    transition: opacity 0.2s ease;
  }
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const HiddenRadio = (styled.input.attrs({ type: 'radio' })`
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;

  &:checked + ${CustomRadio}::after {
    opacity: 1;
  }

  &:focus + ${CustomRadio} {
    box-shadow: 0 0 0 2px rgba(94, 90, 219, 0.3);
  }
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any
